import { types } from 'mobx-state-tree';

const ProductPropertyElement = types.model('ProductPropertyElement', {
  id: types.number,
  name: types.string
});

export default ProductPropertyElement;
